import React, { useEffect } from 'react';

import trackEvent from '@99designs/common/utils/platform/trackEvent';
import { User } from './../../../../../contest/apps/design-details/models/user';
import CircumventionWarningMessage from './../CircumventionWarningMessage';
import useTrackedTriggers from './useTrackedTriggers';

interface Props {
    user: User;
    message: string;
    triggers: string[];
    location: string;
}

function CircumventionWarning({ user, message, triggers, location }: Props) {
    const { hasNewTrigger, setTrackedTriggers } = useTrackedTriggers(triggers);

    useEffect(
        () => {
            if (hasNewTrigger) {
                trackEvent('Circumvention Warning Message Triggered', {
                    location,
                    user,
                    message,
                    triggers,
                });
                setTrackedTriggers(triggers);
            }
        },
        [hasNewTrigger]
    );

    return (
        <CircumventionWarningMessage
            event={{
                event: 'Clicked on circumvention article from private messages',
                meta: { user },
            }}
        />
    );
}

export default CircumventionWarning;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarning/CircumventionWarning.tsx